import { atom, atomFamily, selectorFamily } from "recoil";
import { isNullOrEmpty, isNullOrLengthIsZero } from "shared/Helpers";
import * as componentConstants from "constants/FnolComponentConstants";
import * as fieldMappingConstants from "constants/FieldMappingConstants";
import { generateAutoPopulatedByStringForMultiDropdownField } from "shared/OnPropertyChangeObjects";
import { getFnolInstanceWithThirdPartyState } from "store/UpdateFnolInstanceState";

export const fnolInstanceIsDirty = atom({
  key: "fnolInstanceIsDirty",
  default: true,
});

export const overrideFNOLDataState = atom({
  key: "overrideFNOLDataState",
  default: false,
});

export const getOnPropertyChangeTriggeredByDataAsync = async () => {
  const fnolInstance = await getFnolInstanceWithThirdPartyState();
  const autoPopulatedByData = {};
  for (const field of fnolInstance) {
    if (field.fieldMapping === fieldMappingConstants.ThirdParties) {
      for (const [key, value] of Object.entries(field[componentConstants.AUTO_POPULATED_BY] ?? {})) {
        autoPopulatedByData[key] = value;
      }
    } else if (field.controlType === componentConstants.FNOLCOMPONENT_MULTIOPTIONDROPDOWN) {
      for (const [key, value] of Object.entries(field[componentConstants.AUTO_POPULATED_BY] ?? {})) {
        autoPopulatedByData[generateAutoPopulatedByStringForMultiDropdownField(field.fieldMapping, key)] = value;
      }
    } else {
      autoPopulatedByData[field.fieldMapping] = field[componentConstants.AUTO_POPULATED_BY];
    }
  }

  return autoPopulatedByData;
};

export const enabledParentIdsState = atom({
  key: "enabledParentIdsState",
  default: [],
});

export const isParentIdInEnabledList = selectorFamily({
  key: "isParentIdInEnabledList",
  get:
    (parentLinkIdsArray) =>
    ({ get }) => {
      if (!isNullOrLengthIsZero(parentLinkIdsArray)) {
        const enabledIds = get(enabledParentIdsState);
        let isEnabled = false;
        parentLinkIdsArray.forEach((element) => {
          const result = enabledIds.includes(element.key);
          if (result === true) {
            isEnabled = true;
          }
        });
        return isEnabled;
      }
      return false;
    },
});

export const enabledParentIdsForBlockFieldsState = atomFamily({
  key: "enabledParentIdsForBlockFieldsState",
  default: [],
});

export const isParentIdInEnabledListForBlockFields = selectorFamily({
  key: "isParentIdInEnabledListForBlockFields",
  get:
    ([parentLinkIdsArray, blockItemId]) =>
    ({ get }) => {
      if (!isNullOrLengthIsZero(parentLinkIdsArray)) {
        const enabledIds = get(enabledParentIdsForBlockFieldsState(blockItemId));
        let isEnabled = false;
        parentLinkIdsArray.forEach((element) => {
          const result = enabledIds.includes(element.key);
          if (result === true) {
            isEnabled = true;
          }
        });
        return isEnabled;
      }
      return false;
    },
});

export const getEnabledFilteredDropDownOptionsFromComponent = selectorFamily({
  key: "getEnabledFilteredDropDownOptionsFromComponent",
  get:
    (component) =>
    ({ get }) => {
      let filteredDropdowns = [];
      if (
        component.controlType === componentConstants.FNOLCOMPONENT_DROPDOWN &&
        !isNullOrLengthIsZero(component.parentLinkIdsArray) &&
        !isNullOrLengthIsZero(component.filteredChildDropdownOptions)
      ) {
        const enabledIds = get(enabledParentIdsState);

        component.parentLinkIdsArray.forEach((parentLink) => {
          if (enabledIds.includes(parentLink.key)) {
            const matchedOptions = component.filteredChildDropdownOptions.filter((x) => x.parentId === parentLink.key);
            filteredDropdowns = [...filteredDropdowns, ...matchedOptions];
          }
        });
        return filteredDropdowns;
      }
      return filteredDropdowns;
    },
});
